module.exports = "mutation updateFieldOfLaw($fieldOfLaw:FieldOfLawInput!){updateFieldOfLaw(fieldOfLaw:$fieldOfLaw){name id}}"